<template>
<main>
    <div class="app-view-container">
        <el-row>
            <el-col class="app-view-title">
                <span>{{ $t('tariff.chargeCodes.title') }}</span>
            </el-col>
        </el-row>

        <el-row>
            <el-col>
                <search-filter-list ref="searchFilterList"/>
            </el-col>
        </el-row>

        <el-row class="search-summary-container bg-white">
            <el-col>
                <el-row class="default-section-header">
                    <el-col :span="7" class="default-section-title">
                        <span>{{ $t('tariff.chargeCodes.title') }}</span>
                        <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                            <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="10"  class="default-section-title totals-section">
                        <el-row class="default-section-header"></el-row>
                    </el-col>
                    <el-col :span="7" class="default-section-actions text-align-end">
                        <download-csv/>
                        <span id="manage-shipment-more-actions-section">
                            <add-charge-code />
                        </span>
                    </el-col>
                </el-row>
                <el-row class="search-summary">
                    <el-col>
                        <search-summary-list />
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
    </div>
</main>
</template>

<script>
import AddChargeCode from './components/addChargeCode/addChargeCode';
import SearchFilterList from './SearchFilterList';
import SearchSummaryList from './SearchSummaryList';
import DownloadCsv from './components/downloadCSV/DownloadCSV';

export default {

  name: 'ChargeCodes',
  components: {
    SearchFilterList,
    SearchSummaryList,
    AddChargeCode,
    DownloadCsv
  },

  methods: {
    handleRefresh() {
      this.$refs.searchFilterList.handleSearch();
    },

  }
};

</script>
